export function detachOnDestroy(
  object: Phaser.Group | Phaser.Image,
  sb: Phaser.SignalBinding,
): void {
  if (object instanceof Phaser.Group) {
    object.onDestroy.addOnce(() => sb.detach());
  } else {
    object.events.onDestroy.addOnce(() => sb.detach);
  }
}